import { Modal, Button, Table } from 'react-bootstrap';

const LoanPreCheckModal = ({ show, handleClose, data }) => {
    return (
        <Modal show={show} onHide={handleClose} size="lg" >
            <Modal.Header closeButton>
                <Modal.Title>Loan Pre-Check Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {data ? (
                    <Table hover responsive className="compact-table">
                        <tbody>
                            <tr>
                                <th>Lender</th><td>{data.lender}</td>
                                <th>DistCenter</th><td>{data.distCenterName}</td>
                            </tr>
                            <tr>
                                <th>VizShopName</th><td>{data.vizShopName}</td>
                                <th>VizShopCode</th><td>{data.vizShopCode}</td>
                            </tr>
                            <tr>
                                <th>Deliveryman Name</th><td>{data.deliveryManName}</td>
                                <th>Deliveryman QR Code</th><td>{data.deliveryManQRCode}</td>
                            </tr>
                            <tr>
                                <th>VizPro Invoice Number</th><td>{data.vizproInvoiceNumber}</td>
                                <th>Invoice Number</th><td>{data.invoiceNumber}</td>
                            </tr>
                            <tr>
                                <th>Order Status</th><td>{data.orderStatus}</td>
                                <th>Invoice Amount</th><td>{data.invoiceAmount}</td>
                            </tr>
                            <tr>
                                <th>Paid Amount</th><td>{data.invoicePaidAmount}</td>
                                <th>Pending Amount</th><td>{data.invoicePendingAmount}</td>
                            </tr>
                        </tbody>
                    </Table>
                ) : (
                    <p>No data available.</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default LoanPreCheckModal;
